// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f11ef0d7","508":"b04e635c"}[chunkId] + ".chunk.js";
};